import styled from "styled-components";

export const BoardDiv = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 100%;
  width: 100%;
`;

export const StartGame = styled.button`
  width: 100px;
  height: 2rem;
  background: red;
`;
